<template>
    <v-container fluid>
        <v-row
            align="start"
        >
            <v-col
                cols="12"
            >
                <v-alert
                    color="light-blue darken-4"
                    dark
                    icon="mdi-account"
                    border="top"
                    prominent
                >
                    <v-row align="center">
                        <v-col class="grow text-h4">BPLO Renewal Application</v-col>
                    </v-row>
                </v-alert>
            </v-col>
            <v-col
                cols="12"
            >
                <v-progress-linear
                    v-if="formloaded == false"
                    indeterminate
                    color="red darken-2"
                    height="20"
                    rounded
                    class="mb-5"
                ></v-progress-linear>
                <iframe
                    ref="chartiframe"
                    id="datawrapper-chart-8dfPN" 
                    :src="formsrc"
                    scrolling="yes"
                    frameborder="0"
                    allowtransparency="true"
                    style="width: 0; min-width: 100% !important;"
                    :height="500"
                    @load="onLoad"
                >
                    <v-overlay
                        :absolute="absolute"
                        :value="overlay"
                    ></v-overlay>
                </iframe>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import _ from 'lodash'

export default {
    name: 'bplonew',
    props: ['CheckIfLoggedInInternal'],
    metaInfo: {
        title: 'Digital Tuguegarao - BPLO Business Renewal Application',
    },
    data() {
        return {
            absolute: true,
            overlay: true,
            citizen: {},
            formloaded: false,
            form: '<p>Loading</p>',
            // formsrc: `http://35.220.187.169/FORM/business-renewal?crmauth=${localStorage.getItem('crm_entryauth')}`,
            formsrc: `https://${window.location.hostname}/BPLO/FORM/business-renewal?crmauth=${localStorage.getItem('crm_entryauth')}`,
        }
    },
    methods: {
        onLoad() {
            this.formloaded = true
            this.overlay = false
        }
    },
    mounted() {
        this.CheckIfLoggedInInternal()

        const { user } = this.$jwt.decode(this.$session.get('crmusersessionsignature'), this.jwtsecret)
        user.mobile = user.mobile || ''
        delete user.passwd
        delete user.signature

        this.citizen = _.cloneDeep(user)

        // check
        this.CRM_Interval = setInterval(() => {
            if(!(this.$ls.get('isLoggedIn') && this.$session.exists() && this.$session.get('crmusersessionsignature'))){
                clearInterval(this.CRM_Interval)

                this.$router.push({
                    name: 'login'
                }).catch(()=>{})
            }
        }, 500)
    }
}
</script>

<style scoped>
iframe {
    width: 100%;
}
</style>